/**
 * Constant label for "number" field to use in case selection import csv files.
 * This needs to be defined in front-end due to the "number" header being
 * translated, but when a file gets imported then we need to check by
 * the translated label to get numbers of case to import.
 */
export const ColumnFieldNumberHeaderLabel = 'Toimiku number';
